<template>
  <Sidesheet
    v-if="candidate"
    :active="active"
    @close="closeSidesheet"
  >
    <StatusHeader :candidate="candidate" @close="closeSidesheet"/>
    <div class="wrapper">
      <div class="tabs">
        <Tabs
          :active="activeTab"
          :items="tabItems"
          @change="activeTab = $event"
        />
      </div>
      <History
        v-if="activeTab === 'history'"
        :candidate-info="candidateInfo"
        :loading-candidate-info="loadingCandidateInfo"
      />
      <Documents
        v-if="activeTab === 'documents'"
        :candidate-files="candidateInfo.files ? candidateInfo.files : []"
        :candidate-id="candidateInfo.id"
      />
      <!-- <candidate-modal-edit-form v-if="activeTab === 'edit'" :candidate="candidate" @close="closeSidesheet" /> -->
    </div>
  </Sidesheet>
</template>

<script>
import { mapGetters } from "vuex";

import Sidesheet from "@/components/sidesheet.vue";
import StatusHeader from "@/components/CandidateStatusHeader.vue";
import Tabs from "@/components/tabs.vue";
import History from "@/components/modals/candidate-modal-components/candidate-modal-changes-history.vue";
import Documents from "@/components/modals/candidate-modal-components/candidate-modal-documents.vue";
// import CandidateModalEditForm from "@/components/modals/candidate-modal-components/candidate-modal-edit-form";

const tabItems = [
  // {
  //   label: "Редактирование информации",
  //   value: "edit",
  // },
  {
    label: "История изменений",
    value: "history",
  },
  {
    label: "Документы",
    value: "documents",
  },
];

export default {
  name: "candidate-modal",
  components: {
    Sidesheet,
    StatusHeader,
    Tabs,
    History,
    Documents,
    // CandidateModalEditForm,
  },
  data: () => ({
    active: false,
    activeTab: "history",
    candidate: null,
    candidateInfo: null,
    loadingCandidateInfo: false,
    tabItems,
  }),
  computed: {
    ...mapGetters({
      getCandidate: "candidates/getCandidateById",
    }),
  },
  methods: {
    async openSidesheet({ candidateId, tab } = { tab: "history" }) {
      this.activeTab = tab; 

      this.loadingCandidateInfo = true;
      this.candidateInfo = await this.$store.dispatch("candidates/fetchCandidateInformation", candidateId);
      this.candidate = this.candidateInfo;
      this.loadingCandidateInfo = false;

      this.active = true;
    },
    closeSidesheet() {
      this.active = false;
      this.candidate = null;
      this.candidateComment = "";
      this.$emit("on-close");
    },
  },
  watch: {
    async activeTab() {
      this.candidateInfo = await this.$store.dispatch("candidates/fetchCandidateInformation", this.candidate.id);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.wrapper {
  padding: 0 30px;

  @include onlyStandartMobile {
    padding: 0 20px;
  }
}

.tabs {
  margin: 24px 0 40px;
}

::v-deep {
  .sidesheet__header {
    display: none;
  }

  .sidesheet__wrapper {
    padding: 0;
  }
  
  .c-tabs-shadow {
    left: -29px;
  }
}
</style>
